import gql from "graphql-tag";

export default gql`
	mutation updatePermission($id: ID, $update: Update, $parentId: ID) {
		userPermission(id: $id, update: $update, parentId: $parentId)
	}
`;
